/* Khoob theme — interactions & motion (class-driven, safe across all templates) */
(function () {
  'use strict';

  /* ---------- Decorative line-art motifs (injected into [data-motif]) ---------- */
  var MOTIFS = {
    medallion: (function () {
      var p = ['<circle cx="200" cy="200" r="150"/><circle cx="200" cy="200" r="120"/>'];
      for (var i = 0; i < 8; i++) {
        var a = i * 45 * Math.PI / 180,
          x1 = 200 + Math.cos(a) * 30, y1 = 200 + Math.sin(a) * 30,
          x2 = 200 + Math.cos(a) * 118, y2 = 200 + Math.sin(a) * 118,
          px = 200 + Math.cos(a + 0.4) * 60, py = 200 + Math.sin(a + 0.4) * 60,
          r2 = 200 + Math.cos(a - 0.4) * 60, s2 = 200 + Math.sin(a - 0.4) * 60,
          cx = 200 + Math.cos(a) * 74, cy = 200 + Math.sin(a) * 74;
        p.push('<path d="M' + x1.toFixed(0) + ' ' + y1.toFixed(0) + ' Q' + px.toFixed(0) + ' ' + py.toFixed(0) + ' ' + x2.toFixed(0) + ' ' + y2.toFixed(0) + ' Q' + r2.toFixed(0) + ' ' + s2.toFixed(0) + ' ' + x1.toFixed(0) + ' ' + y1.toFixed(0) + ' Z"/><circle cx="' + cx.toFixed(0) + '" cy="' + cy.toFixed(0) + '" r="4"/>');
      }
      p.push('<circle cx="200" cy="200" r="26"/><circle cx="200" cy="200" r="12"/>');
      for (var j = 0; j < 16; j++) {
        var b = j * 22.5 * Math.PI / 180,
          u1 = 200 + Math.cos(b) * 150, v1 = 200 + Math.sin(b) * 150,
          u2 = 200 + Math.cos(b) * 172, v2 = 200 + Math.sin(b) * 172;
        p.push('<line x1="' + u1.toFixed(0) + '" y1="' + v1.toFixed(0) + '" x2="' + u2.toFixed(0) + '" y2="' + v2.toFixed(0) + '"/>');
      }
      return '<svg viewBox="0 0 400 400"><g fill="none" stroke="currentColor" stroke-width="1" vector-effect="non-scaling-stroke">' + p.join('') + '</g></svg>';
    })(),
    sprig: (function () {
      var p = ['<path d="M60 260 C60 200 60 150 60 20"/>'];
      for (var i = 0; i < 6; i++) { var y = 210 - i * 34, d = i % 2 === 0 ? 1 : -1; p.push('<path d="M60 ' + y + ' C' + (60 + d * 10) + ' ' + (y - 6) + ' ' + (60 + d * 34) + ' ' + (y - 10) + ' ' + (60 + d * 40) + ' ' + (y - 30) + ' C' + (60 + d * 20) + ' ' + (y - 22) + ' ' + (60 + d * 8) + ' ' + (y - 14) + ' 60 ' + (y - 8) + '"/>'); }
      p.push('<path d="M60 22 C50 8 60 -2 60 -2 C60 -2 70 8 60 22 Z"/>');
      return '<svg viewBox="0 0 120 260"><g fill="none" stroke="currentColor" stroke-width="1" vector-effect="non-scaling-stroke">' + p.join('') + '</g></svg>';
    })(),
    star: '<svg viewBox="0 0 400 400"><g fill="none" stroke="currentColor" stroke-width="1" vector-effect="non-scaling-stroke"><rect x="80" y="80" width="240" height="240" transform="rotate(45 200 200)"/><circle cx="200" cy="200" r="130"/><circle cx="200" cy="200" r="66"/><path d="M200 60 L224 176 L340 200 L224 224 L200 340 L176 224 L60 200 L176 176 Z"/><path d="M200 110 L214 186 L290 200 L214 214 L200 290 L186 214 L110 200 L186 186 Z"/></g></svg>',
    blossom: (function () { var p = []; for (var i = 0; i < 6; i++) { p.push('<ellipse cx="60" cy="30" rx="11" ry="26" transform="rotate(' + i * 60 + ' 60 60)"/>'); } p.push('<circle cx="60" cy="60" r="12"/><circle cx="60" cy="60" r="5"/>'); return '<svg viewBox="0 0 120 120"><g fill="none" stroke="currentColor" stroke-width="1" vector-effect="non-scaling-stroke">' + p.join('') + '</g></svg>'; })(),
    bird: '<svg viewBox="0 0 120 100"><g fill="none" stroke="currentColor" stroke-width="1" vector-effect="non-scaling-stroke"><path d="M14 64 C40 40 72 40 96 54"/><path d="M52 50 C58 26 78 22 84 38 C72 42 62 48 56 56"/><path d="M96 54 C104 51 110 53 116 48"/><path d="M14 64 C10 68 7 74 6 82"/><circle cx="100" cy="52" r="1.6"/></g></svg>',
    jali: '<svg viewBox="0 0 1200 24" preserveAspectRatio="none"><g fill="none" stroke="currentColor" stroke-width="1"><line x1="0" y1="12" x2="1200" y2="12" opacity="0.5"/>' + Array.apply(null, { length: 25 }).map(function (_, i) { var x = 24 + i * 48; return '<path d="M' + (x - 14) + ' 12 Q' + x + ' 0 ' + (x + 14) + ' 12 Q' + x + ' 24 ' + (x - 14) + ' 12 Z"/><circle cx="' + x + '" cy="12" r="1.6" fill="currentColor"/>'; }).join('') + '</g></svg>'
  };
  function injectMotifs() {
    document.querySelectorAll('[data-motif]').forEach(function (el) {
      var k = el.getAttribute('data-motif');
      if (MOTIFS[k] && !el.firstElementChild) el.innerHTML = MOTIFS[k];
    });
  }

  /* ---------- Header shadow on scroll ---------- */
  function header() {
    var h = document.querySelector('[data-header]');
    if (!h) return;
    var on = function () { h.classList.toggle('scrolled', window.scrollY > 10); };
    on(); window.addEventListener('scroll', on, { passive: true });
  }

  /* ---------- Mobile nav toggle ---------- */
  function nav() {
    var t = document.querySelector('[data-nav-toggle]'), d = document.querySelector('[data-nav-drawer]');
    if (!t || !d) return;
    t.addEventListener('click', function () { d.classList.toggle('open'); document.body.classList.toggle('nav-open'); });
  }

  /* ---------- Quick-add on hover cards ---------- */
  function quickAdd() {
    document.querySelectorAll('[data-quick-add]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        if (btn.disabled) return;
        var variantId = btn.getAttribute('data-product');
        if (!variantId) return;
        var original = btn.textContent;
        btn.disabled = true; btn.textContent = 'Adding\u2026';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) { if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Unable to add to cart'); }); return res.json(); })
          .then(function () { return fetch('/cart.js'); })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            btn.textContent = 'Added \u25C6';
            var c = document.querySelector('[data-cart-count]');
            if (c) c.textContent = '(' + cart.item_count + ')';
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1500);
          })
          .catch(function (err) {
            btn.textContent = 'Sold out';
            setTimeout(function () { btn.textContent = original; btn.disabled = false; }, 1800);
          });
      });
    });
  }

    /* ---------- Collection card colour swatches ---------- */
  function cardSwatches() {
    document.querySelectorAll('[data-card-swatch]').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var card = sw.closest('.piece');
        if (!card) return;
        card.querySelectorAll('.csw').forEach(function (x) { x.classList.remove('on'); });
        sw.classList.add('on');
        var img = card.querySelector('.piece__img');
        var newSrc = sw.getAttribute('data-variant-img');
        if (img && newSrc) img.src = newSrc;
        var url = sw.getAttribute('data-variant-url');
        if (url) card.setAttribute('href', url);
      });
    });
  }

  /* ---------- Colour swatches ---------- */
  function swatches() {
    document.querySelectorAll('[data-swatches] .sw').forEach(function (sw) {
      sw.addEventListener('click', function () {
        var o = sw.closest('[data-swatches]');
        o.querySelectorAll('.sw').forEach(function (x) { x.classList.toggle('on', x === sw); });
        var chosen = o.querySelector('.opt__chosen'); if (chosen) chosen.textContent = sw.getAttribute('data-name');

        /* Keep the form's selected variant in sync with the chosen colour,
           so the right variant is the one added to cart. */
        var variantId = sw.getAttribute('data-variant-id');
        var form = o.closest('form');
        if (variantId && form) {
          var select = form.querySelector('select[name="id"]');
          var hidden = form.querySelector('input[name="id"]');
          if (select) select.value = variantId;
          else if (hidden) hidden.value = variantId;
        }

        /* Switch the gallery to this colour's photos, matched by alt text
           (e.g. an image alt of "Ikhlas Sage Green 1" matches the "Sage
           Green" swatch). If no photos are tagged for this colour, leave
           the gallery as-is rather than hiding everything. */
        var color = sw.getAttribute('data-color');
        var gallery = document.querySelector('[data-gallery]');
        if (!gallery || !color) return;

        var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.gthumb'));
        var views = Array.prototype.slice.call(gallery.querySelectorAll('.gview'));
        var matchingThumbs = thumbs.filter(function (t) {
          return (t.getAttribute('data-alt') || '').indexOf(color) !== -1;
        });
        var useAll = matchingThumbs.length === 0;
        var visibleThumbs = useAll ? thumbs : matchingThumbs;
        var firstIndex = visibleThumbs.length ? visibleThumbs[0].getAttribute('data-i') : null;

        thumbs.forEach(function (t) {
          var visible = useAll || matchingThumbs.indexOf(t) !== -1;
          t.style.display = visible ? '' : 'none';
          t.classList.toggle('on', t.getAttribute('data-i') === firstIndex);
        });
        views.forEach(function (v) {
          v.classList.toggle('on', v.getAttribute('data-i') === firstIndex);
        });
        gallery.querySelectorAll('.gdot').forEach(function (d) {
          d.classList.toggle('on', d.getAttribute('data-i') === firstIndex);
        });
      });
    });
  }

  /* ---------- Product gallery thumbnails ---------- */
  function gallery() {
    document.querySelectorAll('[data-gallery]').forEach(function (g) {
      function showIndex(i) {
        g.querySelectorAll('.gthumb').forEach(function (x) { x.classList.toggle('on', x.getAttribute('data-i') === i); });
        g.querySelectorAll('.gview').forEach(function (v) { v.classList.toggle('on', v.getAttribute('data-i') === i); });
        g.querySelectorAll('.gdot').forEach(function (d) { d.classList.toggle('on', d.getAttribute('data-i') === i); });
      }

      g.querySelectorAll('.gthumb').forEach(function (t) {
        t.addEventListener('click', function () { showIndex(t.getAttribute('data-i')); });
      });
      g.querySelectorAll('.gdot').forEach(function (d) {
        d.addEventListener('click', function () { showIndex(d.getAttribute('data-i')); });
      });

      /* Swipe left/right on the main image to move between photos (mobile).
         Only considers currently-visible thumbs, so it respects whatever
         colour filter is active. */
      var main = g.querySelector('.gmain');
      if (!main) return;
      var startX = 0, startY = 0, tracking = false;

      function visibleThumbs() {
        return Array.prototype.slice.call(g.querySelectorAll('.gthumb'))
          .filter(function (t) { return t.style.display !== 'none'; });
      }

      main.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        tracking = true;
      }, { passive: true });

      main.addEventListener('touchend', function (e) {
        if (!tracking) return;
        tracking = false;
        var dx = e.changedTouches[0].clientX - startX;
        var dy = e.changedTouches[0].clientY - startY;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;

        var thumbs = visibleThumbs();
        if (thumbs.length < 2) return;
        var current = thumbs.findIndex(function (t) { return t.classList.contains('on'); });
        if (current === -1) current = 0;
        var next = dx < 0 ? current + 1 : current - 1;
        if (next < 0) next = thumbs.length - 1;
        if (next >= thumbs.length) next = 0;
        showIndex(thumbs[next].getAttribute('data-i'));
      }, { passive: true });
    });
  }

  /* ---------- Quantity stepper ---------- */
  function qty() {
    document.querySelectorAll('[data-qty]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('button').forEach(function (btn) {
        btn.addEventListener('click', function () { var n = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.getAttribute('data-q'), 10)); input.value = n; });
      });
    });
  }

  /* ---------- Listing: filter + sort ---------- */
  function listing() {
    var grid = document.querySelector('[data-grid]');
    if (!grid) return;
    var cards = Array.prototype.slice.call(grid.children);
    var countEl = document.querySelector('[data-count]'), emptyEl = document.querySelector('[data-empty]');
    var current = 'all';
    function apply() {
      var shown = 0;
      cards.forEach(function (c) { var ok = current === 'all' || c.getAttribute('data-coll') === current; c.classList.toggle('hide', !ok); if (ok) shown++; });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
      if (emptyEl) emptyEl.classList.toggle('on', shown === 0);
    }
    document.querySelectorAll('[data-filter]').forEach(function (f) {
      f.addEventListener('click', function () { document.querySelectorAll('[data-filter]').forEach(function (x) { x.classList.toggle('on', x === f); }); current = f.getAttribute('data-filter'); apply(); });
    });
    var sort = document.querySelector('[data-sort]');
    if (sort) sort.addEventListener('change', function (e) {
      var v = e.target.value, arr = cards.slice();
      arr.sort(function (a, b) {
        if (v === 'low') return a.dataset.price - b.dataset.price;
        if (v === 'high') return b.dataset.price - a.dataset.price;
        if (v === 'az') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
        return cards.indexOf(a) - cards.indexOf(b);
      });
      arr.forEach(function (c) { grid.appendChild(c); });
    });
    apply();
  }

  /* ---------- Atelier popup ---------- */
  function atelier() {
    var pop = document.querySelector('[data-atelier]');
    if (!pop) return;
    var card = pop.querySelector('.atelier'), KEY = 'khoob_atelier_seen', shown = false;
    function seen() { try { return sessionStorage.getItem(KEY) === '1'; } catch (e) { return window.__khoobSeen; } }
    function mark() { try { sessionStorage.setItem(KEY, '1'); } catch (e) { window.__khoobSeen = true; } }
    function open() { if (shown || seen()) return; shown = true; mark(); pop.classList.add('open'); pop.setAttribute('aria-hidden', 'false'); setTimeout(function () { var e = pop.querySelector('input'); if (e) e.focus(); }, 450); }
    function close() { pop.classList.remove('open'); pop.setAttribute('aria-hidden', 'true'); }
    var delay = parseInt(pop.getAttribute('data-delay'), 10) || 4000;
    setTimeout(open, delay);
    document.addEventListener('mouseleave', function (ev) { if (ev.clientY <= 0) open(); });
    var x = pop.querySelector('[data-atelier-close]'); if (x) x.addEventListener('click', close);
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('open')) close(); });
    var form = pop.querySelector('form');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var orig = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
      /* Shopify contact form: follow the redirect and read res.url for the
         success flag, same reliable pattern as the booking form. Only show
         success on a genuine OK so the email + WhatsApp number really send. */
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' },
        redirect: 'follow'
      })
        .then(function (res) {
          if (res.url && res.url.indexOf('contact_posted=false') !== -1) throw new Error('failed');
          card.classList.add('done'); setTimeout(close, 2800);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = 'Try again'; }
        });
    });
  }

  /* ---------- Booking modal (sold-out product enquiry) ---------- */
  function bookModal() {
    var pop = document.querySelector('[data-book]');
    if (!pop) return;
    var card = pop.querySelector('.book');
    var openBtn = document.querySelector('[data-book-open]');
    var errEl = pop.querySelector('[data-book-error]');

    function open() {
      pop.classList.add('open');
      pop.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { var e = pop.querySelector('input,select'); if (e) e.focus(); }, 400);
    }
    function close() {
      pop.classList.remove('open');
      pop.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    if (openBtn) openBtn.addEventListener('click', open);
    pop.querySelectorAll('[data-book-close]').forEach(function (b) { b.addEventListener('click', close); });
    pop.addEventListener('click', function (e) { if (e.target === pop) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && pop.classList.contains('open')) close(); });

    var form = pop.querySelector('form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) errEl.hidden = true;
      var submitBtn = form.querySelector('[type="submit"]');
      var originalText = submitBtn ? submitBtn.textContent : '';
      if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending\u2026'; }

      /* Shopify's contact form doesn't return JSON — on success it redirects
         to <page>?contact_posted=true, on validation error to ?contact_posted=false.
         We follow the redirect and read res.url for that flag. A network failure
         rejects and shows the error. (Email delivery already confirms the POST
         itself works; this just drives the on-screen state.) */
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'Accept': 'text/html' },
        redirect: 'follow'
      })
        .then(function (res) {
          if (res.url && res.url.indexOf('contact_posted=false') !== -1) {
            throw new Error('validation failed');
          }
          card.classList.add('done');
        })
        .catch(function () {
          if (errEl) errEl.hidden = false;
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        });
    });
  }

  /* ---------- Motion (GSAP if present, otherwise reveal everything) ---------- */
  function motion() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var G = window.gsap;
    if (!G || reduce) { document.querySelectorAll('.reveal,.cov,.cov-t').forEach(function (e) { e.classList.add('in'); }); return; }
    if (G.registerPlugin && window.ScrollTrigger) G.registerPlugin(window.ScrollTrigger);
    var ST = window.ScrollTrigger;

    // cover / hero entrance
    if (document.querySelector('.cov,.cov-t')) {
      var tl = G.timeline({ defaults: { ease: 'power3.out' } });
      if (document.querySelector('.cov-t')) tl.from('.cov-t', { clipPath: 'inset(115% 0 0 0)', y: 24, duration: 1.2, ease: 'power4.out' }, 0);
      tl.from('.cov', { opacity: 0, y: 22, duration: 1, stagger: 0.1 }, 0.15);
    }
    G.utils.toArray('[data-hero-text]').forEach(function () {});
    if (document.querySelector('[data-hero-text]')) G.from('[data-hero-text]', { opacity: 0, y: 26, duration: 1.1, stagger: 0.14, ease: 'power3.out', delay: 0.2 });

    // hero motif draws itself in with colour
    var hm = document.querySelectorAll('[data-hero-motif] path,[data-hero-motif] line,[data-hero-motif] circle');
    if (hm.length) {
      hm.forEach(function (p) { var L; try { L = p.getTotalLength(); } catch (e) { L = 300; } if (!L) L = 300; G.set(p, { strokeDasharray: L, strokeDashoffset: L }); });
      G.set('[data-hero-motif]', { opacity: 0 });
      G.to('[data-hero-motif]', { opacity: 0.8, duration: 0.6, ease: 'power1.out', delay: 0.3 });
      G.to(hm, { strokeDashoffset: 0, duration: 3, ease: 'power2.out', stagger: 0.006, delay: 0.3 });
      if (ST) G.to('[data-hero-motif]', { yPercent: 12, ease: 'none', scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } });
    }

    if (!ST) { document.querySelectorAll('.reveal').forEach(function (e) { e.classList.add('in'); }); return; }

    // headings clip-rise
    G.utils.toArray('[data-rise]').forEach(function (h) { h.classList.remove('reveal'); G.from(h, { clipPath: 'inset(115% 0 0 0)', y: 18, duration: 1.05, ease: 'power3.out', scrollTrigger: { trigger: h, start: 'top 88%' } }); });
    // generic reveals
    G.utils.toArray('.reveal').forEach(function (el) { ST.create({ trigger: el, start: 'top 88%', onEnter: function () { el.classList.add('in'); } }); });
    // diamond dividers
    G.utils.toArray('.divide').forEach(function (d) { var l = d.querySelectorAll('.l'), dia = d.querySelector('.dia'); var t = G.timeline({ scrollTrigger: { trigger: d, start: 'top 90%' } }); t.from(l, { scaleX: 0, duration: 1.1, ease: 'power3.out' }, 0).from(dia, { scale: 0, duration: 0.6, ease: 'back.out(2)' }, 0.2); });
    // seals
    G.utils.toArray('.seal').forEach(function (s) { if (s.closest('.hero')) return; G.from(s.querySelectorAll('.dia'), { scale: 0, duration: 0.6, stagger: 0.08, ease: 'back.out(2)', scrollTrigger: { trigger: s, start: 'top 92%' } }); });
    // media unveils + parallax
    G.utils.toArray('[data-unveil]').forEach(function (m) {
      G.fromTo(m, { clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0% 0)', duration: 1.2, ease: 'power3.out', scrollTrigger: { trigger: m, start: 'top 88%' } });
      var inner = m.querySelector('.m'); if (inner) G.fromTo(inner, { yPercent: -6 }, { yPercent: 6, ease: 'none', scrollTrigger: { trigger: m, start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    // motifs that draw themselves in
    G.utils.toArray('[data-draw] svg').forEach(function (svg) {
      var el = svg.querySelectorAll('path,line,circle,ellipse');
      el.forEach(function (p) { var L; try { L = p.getTotalLength(); } catch (e) { L = 200; } if (!L) L = 200; G.set(p, { strokeDasharray: L, strokeDashoffset: L }); });
      G.to(el, { strokeDashoffset: 0, duration: 1.9, ease: 'power2.out', stagger: 0.02, scrollTrigger: { trigger: svg, start: 'top 85%' } });
    });
  }

  /* ---------- Product image lightbox: zoom, pan, pinch ---------- */
  function productLightbox() {
    var lb = document.getElementById('productLightbox');
    if (!lb) return;
    var img = document.getElementById('lbImg');
    var stage = document.getElementById('lbStage');
    var counter = document.getElementById('lbCounter');
    var hint = document.getElementById('lbHint');
    var scale = 1, panX = 0, panY = 0;
    var MIN_SCALE = 1, MAX_SCALE = 4;
    var dragging = false, dragStartX = 0, dragStartY = 0, dragPanX = 0, dragPanY = 0;
    var hintTimer;

    function getTriggers() {
      /* Re-read on every open, since colour swatches can hide/show gview
         elements after the page has loaded. */
      return Array.prototype.slice.call(document.querySelectorAll('[data-lightbox-trigger]'));
    }

    function applyTransform() { img.style.transform = 'scale(' + scale + ') translate(' + panX + 'px,' + panY + 'px)'; }
    function resetZoom() { scale = 1; panX = 0; panY = 0; applyTransform(); stage.classList.remove('zoomed', 'dragging'); }
    function clampPan() {
      if (scale <= 1) { panX = 0; panY = 0; return; }
      var rect = img.getBoundingClientRect();
      var stageRect = stage.getBoundingClientRect();
      var maxPanX = Math.max(0, (rect.width - stageRect.width) / (2 * scale));
      var maxPanY = Math.max(0, (rect.height - stageRect.height) / (2 * scale));
      panX = Math.max(-maxPanX, Math.min(maxPanX, panX));
      panY = Math.max(-maxPanY, Math.min(maxPanY, panY));
    }

    var srcs = [], alts = [], idx = 0;
    var preloaded = {};

    function preload(i) {
      if (i < 0 || i >= srcs.length || preloaded[i] || !srcs[i]) return;
      var im = new Image();
      im.src = srcs[i];
      preloaded[i] = true;
    }

    function showImage(i) {
      idx = i;
      resetZoom();
      img.src = srcs[idx] || '';
      img.alt = alts[idx] || '';
      counter.textContent = (idx + 1) + ' / ' + srcs.length;
      /* Preload neighbours so prev/next feels instant instead of showing
         the previous frame while the next full-res image downloads. */
      preload((idx + 1) % srcs.length);
      preload((idx - 1 + srcs.length) % srcs.length);
    }
    function openLb(triggers, startIdx) {
      srcs = triggers.map(function (t) { var im = t.querySelector('img'); return im ? (im.getAttribute('data-full') || im.src) : ''; });
      alts = triggers.map(function (t) { var im = t.querySelector('img'); return im ? (im.alt || '') : ''; });
      preloaded = {};
      showImage(startIdx);
      lb.classList.add('open');
      lb.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      if (hint) { hint.classList.remove('hide'); clearTimeout(hintTimer); hintTimer = setTimeout(function () { hint.classList.add('hide'); }, 3000); }
    }
    function closeLb() {
      lb.classList.remove('open');
      lb.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      resetZoom();
    }
    function prev() { if (srcs.length > 1) showImage((idx - 1 + srcs.length) % srcs.length); }
    function next() { if (srcs.length > 1) showImage((idx + 1) % srcs.length); }

    /* Delegate the click so it keeps working even after swatches() re-filters
       which gview elements are visible. Only the currently-visible triggers
       are passed to the lightbox, so prev/next stay within the active colour. */
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lightbox-trigger]');
      if (!trigger) return;
      var gallery = trigger.closest('[data-gallery]');
      var allTriggers = getTriggers().filter(function (t) {
        return !gallery || t.closest('[data-gallery]') === gallery;
      });
      var visibleTriggers = allTriggers.filter(function (t) { return t.style.display !== 'none'; });
      var pool = visibleTriggers.length ? visibleTriggers : allTriggers;
      var startIdx = pool.indexOf(trigger);
      if (startIdx === -1) startIdx = 0;
      openLb(pool, startIdx);
    });

    /* scroll-to-zoom (desktop) */
    stage.addEventListener('wheel', function (e) {
      e.preventDefault();
      var delta = e.deltaY > 0 ? -0.3 : 0.3;
      scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, scale + delta));
      if (scale <= 1) { resetZoom(); } else { clampPan(); stage.classList.add('zoomed'); }
      applyTransform();
      if (hint) hint.classList.add('hide');
    }, { passive: false });

    /* drag-to-pan (desktop) */
    stage.addEventListener('mousedown', function (e) {
      if (scale <= 1) return;
      e.preventDefault();
      dragging = true;
      dragStartX = e.clientX; dragStartY = e.clientY;
      dragPanX = panX; dragPanY = panY;
      stage.classList.add('dragging');
    });
    document.addEventListener('mousemove', function (e) {
      if (!dragging) return;
      panX = dragPanX + (e.clientX - dragStartX) / scale;
      panY = dragPanY + (e.clientY - dragStartY) / scale;
      clampPan();
      applyTransform();
    });
    document.addEventListener('mouseup', function () { if (dragging) { dragging = false; stage.classList.remove('dragging'); } });

    /* double-click to toggle zoom */
    stage.addEventListener('dblclick', function (e) {
      e.preventDefault();
      if (scale > 1) { resetZoom(); } else {
        scale = 2.5;
        stage.classList.add('zoomed');
        applyTransform();
      }
    });

    /* pinch-to-zoom + one-finger pan (mobile) */
    var lastDist = 0, touching = false;
    function getDist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY); }

    stage.addEventListener('touchstart', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        lastDist = getDist(e.touches);
      } else if (e.touches.length === 1 && scale > 1) {
        e.preventDefault();
        touching = true;
        dragStartX = e.touches[0].clientX; dragStartY = e.touches[0].clientY;
        dragPanX = panX; dragPanY = panY;
      }
    }, { passive: false });

    stage.addEventListener('touchmove', function (e) {
      if (e.touches.length === 2) {
        e.preventDefault();
        var dist = getDist(e.touches);
        var ratio = dist / lastDist;
        scale = Math.max(MIN_SCALE, Math.min(MAX_SCALE, scale * ratio));
        lastDist = dist;
        if (scale <= 1) { resetZoom(); } else { clampPan(); stage.classList.add('zoomed'); }
        applyTransform();
      } else if (e.touches.length === 1 && touching && scale > 1) {
        e.preventDefault();
        panX = dragPanX + (e.touches[0].clientX - dragStartX) / scale;
        panY = dragPanY + (e.touches[0].clientY - dragStartY) / scale;
        clampPan();
        applyTransform();
      }
    }, { passive: false });

    stage.addEventListener('touchend', function () { touching = false; lastDist = 0; });

    /* click stage (not zoomed) to close */
    stage.addEventListener('click', function (e) {
      if (scale <= 1 && e.target === stage) closeLb();
    });

    document.getElementById('lbClose').addEventListener('click', closeLb);
    document.getElementById('lbPrev').addEventListener('click', function (e) { e.stopPropagation(); prev(); });
    document.getElementById('lbNext').addEventListener('click', function (e) { e.stopPropagation(); next(); });

    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') closeLb();
      if (e.key === 'ArrowLeft') prev();
      if (e.key === 'ArrowRight') next();
      if (e.key === '+' || e.key === '=') { scale = Math.min(MAX_SCALE, scale + 0.5); clampPan(); stage.classList.add('zoomed'); applyTransform(); }
      if (e.key === '-') { scale = Math.max(MIN_SCALE, scale - 0.5); if (scale <= 1) resetZoom(); else { clampPan(); applyTransform(); } }
    });
  }

  function init() {
    injectMotifs(); header(); nav(); quickAdd(); swatches(); cardSwatches(); gallery(); qty(); listing(); atelier(); bookModal(); motion(); productLightbox();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();